/**
 * useFeatureFlags - bulk React Query hook
 *
 * Fetches the resolved flag list (single endpoint that already takes the user's
 * opt-in cookies into account). Cached aggressively because flags rarely change
 * and we want every gated render to be near-instant after the first load.
 */
import { useQuery } from '@tanstack/react-query';
import { featureFlagService, type ResolvedFlag } from '@/services/feature-flag.service';

export const FEATURE_FLAGS_QUERY_KEY = ['feature-flags'] as const;

export function useFeatureFlags() {
  return useQuery<ResolvedFlag[]>({
    queryKey: FEATURE_FLAGS_QUERY_KEY,
    queryFn: () => featureFlagService.resolve(),
    staleTime: 5 * 60 * 1000,
    // Control-plane flags (AI kill-switch, Fluxos, billing) must propagate to an
    // open app WITHOUT a reload. The backend is the real gate; this is only UX.
    // Refetch on focus + every 5min so a master flip lands within a window.
    refetchOnWindowFocus: true,
    refetchInterval: 5 * 60 * 1000,
  });
}
